import ContextCompanyProfile from './ContextCompanyProfile'

export default ContextCompanyProfile
